import { get } from '../../../utils/api';

export default {
  getSaiplayRead: () => get({ url: 'sailplay/read' }),
};
